import React from "react";
import { formatDate } from "utils";
import styled from "styled-components";
import { Link } from "react-router-dom";

const SingleEvent = ({
  event_date,
  event_owner,
  event_repo,
  event_title,
  event_id,
}) => {
  if (!event_id) {
    return <NoEventMsg>No Scheduled Mission</NoEventMsg>;
  }

  return (
    <StyledLink to={`/events/${event_id}`}>
      <EventContainer key={event_title + event_date}>
        <div>{event_title}</div>
        <div>{formatDate({ date: event_date })}</div>
        <div>Event Host: {event_owner}</div>
        <div>Repo: {event_repo}</div>
      </EventContainer>
    </StyledLink>
  );
};

const EventContainer = styled.div`
  padding: 15px 15px 2px 15px;
  margin: 5px 5px 2px 5px;
  > div {
    text-align: center;
    padding: 2px;
  }

  div:first-child {
    font-weight: bold;
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: #d3d3d4;
`;

const NoEventMsg = styled.div`
  padding-top: 25px;
`;

export default SingleEvent;
